<template>
  <section class="section stories-section reveal-section" id="historias" ref="sectionRef">
    <div class="section-header">
      <span class="section-label">Transformación</span>
      <h2 class="section-title">Historias de Impacto Real</h2>
      <p class="section-subtitle">Vidas que inspiran generación tras generación</p>
    </div>
    <div class="cards-grid">
      <ion-card v-for="(story, i) in stories" :key="i" class="story-card">
        <div class="story-image" :style="{ background: story.gradient }">
          <div>{{ story.emoji }}</div>
        </div>
        <ion-card-content>
          <div class="story-meta">
            <span class="story-dot" :style="{ background: story.dotColor }"></span>
            <span class="story-tag" :style="{ color: story.dotColor }">{{ story.tag }}</span>
          </div>
          <h3 class="story-title">{{ story.title }}</h3>
          <p class="story-text">{{ story.text }}</p>
          <div class="story-footer">
            <span class="story-time" :style="{ color: story.dotColor }">{{ story.time }}</span>
            <span class="story-arrow">→</span>
          </div>
        </ion-card-content>
      </ion-card>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { IonCard, IonCardContent } from '@ionic/vue'
import { useScrollReveal } from '@/composables/useAnimations'

const sectionRef = ref<HTMLElement | null>(null)
const { registerReveal } = useScrollReveal()
onMounted(() => registerReveal(sectionRef.value))

const stories = ref([
  { emoji: '👨‍🎓', gradient: 'linear-gradient(135deg,var(--vh-azul-cielo),var(--vh-dorado))', dotColor: 'var(--vh-verde)', tag: 'Historia de Éxito', title: 'Juan - De Sueños a Realidad', text: 'Juan llegó a Vision House sin esperanza. A través de nuestro programa de liderazgo, descubrió su potencial. Hoy es líder en su comunidad, impactando a más de 200 jóvenes.', time: '2 años en el programa' },
  { emoji: '👩‍💼', gradient: 'linear-gradient(135deg,var(--vh-rosa),var(--vh-dorado))', dotColor: 'var(--vh-rosa)', tag: 'Empoderamiento', title: 'María - Rompiendo Barreras', text: 'María enfrentaba barreras económicas y sociales. Con apoyo de Vision House, completó su educación superior y ahora trabaja como profesional, siendo modelo para su comunidad.', time: '3 años de transformación' },
  { emoji: '🤝', gradient: 'linear-gradient(135deg,var(--vh-verde),var(--vh-azul-cielo))', dotColor: 'var(--vh-verde)', tag: 'Servicio Social', title: 'Carlos - Retribución al Impacto', text: 'Carlos recibió ayuda cuando más la necesitaba. Ahora como voluntario en Vision House, ha ayudado a 150+ jóvenes a encontrar su propósito y camino.', time: '1 año voluntariando' }
])
</script>

<style scoped>
.stories-section { background: linear-gradient(135deg, var(--vh-gris-piedra) 0%, rgba(255,255,255,0.5) 100%); }
.cards-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(320px, 1fr)); gap: 2rem; max-width: 1200px; margin: 0 auto; }
.story-card {
  background: white; border-radius: 16px; overflow: hidden;
  box-shadow: 0 8px 30px var(--vh-sombra); transition: all 0.3s;
  position: relative;
}
.story-card:hover { transform: translateY(-16px) scale(1.02); box-shadow: 0 20px 50px var(--vh-sombra); }
.story-image {
  height: 200px; position: relative; overflow: hidden;
  display: flex; align-items: center; justify-content: center; font-size: 3.5rem;
}
.story-image::after {
  content: ''; position: absolute; inset: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.2) 50%, transparent 70%);
  animation: shimmer 2s infinite;
}
.story-image > div { position: relative; z-index: 2; animation: iconPop 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) 0.2s both; }
@keyframes iconPop { 0% { transform: scale(0.5) rotate(-10deg); opacity: 0; } 50% { transform: scale(1.1); } 100% { transform: scale(1) rotate(0deg); opacity: 1; } }
.story-meta { display: flex; align-items: center; gap: 0.8rem; margin-bottom: 1rem; }
.story-dot { width: 12px; height: 12px; border-radius: 50%; animation: dotsPulse 1.5s ease-in-out infinite; }
@keyframes dotsPulse { 0%, 100% { opacity: 0.3; } 50% { opacity: 1; } }
.story-tag { font-size: 0.85rem; font-weight: 600; text-transform: uppercase; letter-spacing: 1px; }
.story-title { font-size: 1.4rem; color: var(--vh-azul-profundo); margin-bottom: 1rem; }
.story-text { color: #555; line-height: 1.8; margin-bottom: 1.5rem; font-size: 0.95rem; }
.story-footer { display: flex; justify-content: space-between; align-items: center; padding-top: 1rem; border-top: 1px solid #eee; }
.story-time { font-size: 0.85rem; font-weight: 600; }
.story-arrow { font-size: 1.2rem; animation: float 3s ease-in-out infinite; }
</style>
